import React from 'react'
import { FormDashboardTextarea } from '../dashboard-form'
import { Button } from '../buttons'
import { MobileViewportProvider } from '../../utils'

const CommentForm = () => {
  return (
    <div>
      <p className="text-lg font-bold mb-4">Leave a Comment</p>
      <form>
        <div className="mb-4 lg:mb-6">
          <FormDashboardTextarea className="w-full"/>
        </div>
        <div className="block lg:inline-block">
          <Button className="hidden lg:inline-block">Post Comment</Button>
          <MobileViewportProvider>
            <Button className="w-full" thin>Post Comment</Button>
          </MobileViewportProvider>
        </div>
      </form>
    </div>
  )
}

export { CommentForm }